import { render } from "./PartnerClientListView.vue?vue&type=template&id=254e3c1e&scoped=true"
import script from "./PartnerClientListView.vue?vue&type=script&lang=js"
export * from "./PartnerClientListView.vue?vue&type=script&lang=js"

import "./PartnerClientListView.vue?vue&type=style&index=0&id=254e3c1e&lang=scss&scoped=true"

import exportComponent from "C:\\Projects\\fxhub-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-254e3c1e"]])

export default __exports__